import {
	CollectionModelState,
	CollectionModelStateProxy,
	Geometry3D,
	type IMap,
	type ModelFieldState,
} from '@ikegps/core-shared';
import { makeObservable } from 'mobx';
import { ObservableIMap } from '../util/observable.map';

export class CollectionModelStateEdit extends CollectionModelStateProxy {
	fields: IMap<ModelFieldState> = new ObservableIMap<ModelFieldState>();
	geometries: IMap<Geometry3D> = new ObservableIMap<Geometry3D>();

	constructor(state: CollectionModelState) {
		super(state);
		makeObservable(this);
	}

	override reset() {
		super.reset();
	}

	override setFieldValue<T extends ModelFieldState>(fieldId: string, state: T): void {
		super.setFieldValue(fieldId, state);
	}
}
